<template>
    <div>
       
        <div class="titleInvite" >
            <div style="float: left">
            <a  v-on:click="home" >
                <img src="@/assets/logoMenu.png" class="logo" />
            </a>
            </div>
           
        </div>
        <div v-if="!errorNotMembre">
            <div class="inviteDescription">
                On vous a invité à être membre du club {{club}}    
            </div>
            <div class="inviteDescription">
                Connectez vous ou créer votre compte avec votre email : {{email}}
            </div>
            <div class="alertEmail">
                Attention si vous vous connectez avec un autre email, il est possible que vous ne puissez pas voir le club {{club}} !!!
            </div>
        
            <div class="login">
                <login v-if="notConnecte" @club="GoTOclub"/>
            </div>
        </div>
        <div v-if="errorNotMembre" class="inviteDescription">
           <div v-if ="email!=$store.getters.getUser.email">
                On vous a invité à être membre du club {{club}} avec l'email {{email}}<br/>
                Mais vous êtes connecté avec l'email {{$store.getters.getUser.email}}
                <br/>
                Soit : vous devez vous déconnecter et vous reconnecter avec l'email {{email}}
                <s-button theme="is-danger" label="Me déconnecter" @onclick="logout"/><br/><br/>
                Soit : vous devez demander au propriétaire du club {{club}} de renseigner votre email {{$store.getters.getUser.email}} 
                <s-button @onclick="home" theme="is-warning " label="Revenir à l'accueil" icon="undo"/>
            </div>
            <div v-if ="email==$store.getters.getUser.email">
                Oups ... A priori le propriétaire a dû changer d'avis, vous ne faites pas parti du club {{club}}<br/>
                <s-button @onclick="home" theme="is-warning is-large" label="Revenir à l'accueil" icon="undo"/>
            </div>
        </div>
    </div>
</template>
<style scoped>
   
   
    @media screen and (min-width: 420px) {
         .login {
            padding: 10px;
            background-color: rgb(92, 130, 255);
            
        }
        .titleInvite {
            background-color: rgb(92, 130, 255);
            font-size: 36px;
            padding: 20px;
            color: white;
            height: 300px;
        }
         .logo {
                width: 300px;
                margin-left: 10px;
                padding-top: 5px;
        }
        .inviteDescription {
                background-color: rgb(92, 130, 255);
                font-size: 30px;
                padding: 20px;
                color: white;
            }
        .alertEmail {
            background-color: rgb(92, 130, 255);
            color: rgb(238, 226, 226);
            font-size: 30px;
            font-weight: bolder;
            padding: 20px;
            
        }
    }
    @media screen and (max-width: 420px) {
        .alertEmail {
            background-color: rgb(92, 130, 255);
            color: rgb(238, 226, 226);
            font-size: 15px;
            font-weight: bolder;
            padding: 5px;
            
        }
        .inviteDescription {
            background-color: rgb(92, 130, 255);
            font-size: 15px;
            padding: 5px;
            color: white;
        }
         .login {
            padding: 10px;
            background-color: rgb(92, 130, 255);
            margin-top: -800px;
        }
        .titleInvite {
            background-color: rgb(92, 130, 255);
            font-size: 36px;
            padding: 20px;
            color: white;
            height: 130px;
        }
         .logo {
                width: 150px;
                margin-left: auto;
                margin-right: auto;
                padding-top: 5px;
        }
    }
     
    
</style>
<script>
import firebase_api from "@/firebase/firebase_api"; 
import login from "@/views/auth/Login.vue"; 
import firebase from "firebase/app"
export default {
    data() {
        return {
            idClub: null,
            club: null,
            email: null,
            notConnecte: false,
            errorNotMembre: false
        }
    },
    components: {
        login
    },
    methods: {
        GoTOclub: function() {
            this.$router.push({name: "viewClub" , params: {id: this.$route.params.id}});
        },
        logout: function() {
            firebase
                .auth()
                .signOut()
                .then(() => {
                this.$store.dispatch('init',()=>{
                      this.refresh();
                });
            });
        },
        home: function() {
      
          this.$router.push({name: "home"})
            .then(()=>{})
            .catch(error=>{
            });
        },
        refresh() {
            this.club = this.$route.params.club;
            this.email = this.$route.params.email;
             this.errorNotMembre = false;
            if (this.$store.getters.getUser != null) {
                // si il est déjà connecte
                // 2 cas de figure
                // si le joueur connecte est bien joueur du club alors on le redirige vers le club
                // si le joueur connecte n'est pas joueur du club... on lui met un message
                // pour qu'il se déconnecte et se reconnecte avec l'adresse passé en paramètres
                this.notConnecte = false;
                var user = this.$store.getters.getUser;
                if (typeof(user.clubs)!="undefined") {
                    if (user.clubs.findIndex(elt=>elt.idClub === this.$route.params.id) != -1) {
                        this.$router.push({name: "viewClub" , params: {id: this.$route.params.id}});
                        }
                    else {
                        this.errorNotMembre = true;
                    }
                }
                else {
                    this.errorNotMembre = true;
                }
            }
            else {
                // le joueur n'est pas connecte
                this.notConnecte = true;
            }
        }
    },
    mounted() {
       this.refresh();
    }
}
</script>